<template>
  <div class="select_list">
    <p v-if="!selected" v-for="item in list" :key="item.value" class="filter_select">
      <label>
        <input type="checkbox" :value="item.value" />
        {{ item.label }}<i v-if="item.pending" class="icon_pending"></i>
      </label>
    </p>
    <p v-else v-for="item in list" :key="item.value">
      {{ item.label }}
      <Base.Button size="xs" icon="delete" txt="none">삭제</Base.Button>
    </p>
  </div>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { Base } from "../BaseFactory";

const props = defineProps({
  checked: Boolean,
  modelValue: { type: String, default: "" },
  list: { type: Array<{ label: string; value: string }>, default: () => [] },
  selected: {
    type: Boolean,
    default: false,
  },
  pending: {
    type: Boolean,
    default: false,
  },
});
</script>
